var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 17.9487L18.154 5.02554C18.8991 4.4294 19.9617 4.44277 20.6916 5.05746L36 17.9487",
    stroke: "#8A96A3",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6397 14.0254V31.1408C31.6397 32.5215 30.5205 33.6408 29.1397 33.6408H25.4218C24.0411 33.6408 22.9218 32.5215 22.9218 31.1408V30.0382C22.9218 28.6575 21.8025 27.5382 20.4218 27.5382H18.4474C17.0667 27.5382 15.9474 28.6575 15.9474 30.0382V31.1408C15.9474 32.5215 14.8282 33.6408 13.4474 33.6408H9.72949C8.34878 33.6408 7.22949 32.5215 7.22949 31.1408V14.0254",
    stroke: "#8A96A3",
    strokeWidth: 2.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.396a44755bfbe8e8ed5f0b1f0c4d5461.svg";
export { ForwardRef as ReactComponent };